<template>
  <div>
    <div
      class="dropzone relative"
      :class="{ 'has-error' : error }"
    >
      <div
        @dragenter.prevent="toggleActive"
        @dragleave.prevent="toggleActive"
        @dragover.prevent
        @drop.prevent="onDrop"
        :class="{
          'bg-blue-100': active,
        }"
        class="dropzone-custom-content"
      >
        <span class="icon-upload text-blue-300"></span>
        <p class="dropzone-title">{{ title }} <span v-if="required">*</span></p>
        <label for="dropzoneFile" class="dropzone-baseline cursor-pointer duration-300">{{ baseline }}</label>
        <div class="mt-3">
          <slot :placeholder="getPlaceholder" :size="getFileSize">{{ getPlaceholder }}</slot>
          <input :name="name" @change="onChange" class="hidden dropzoneFile" ref="dropzone" type="file" id="dropzoneFile" />
        </div>
      </div>
    </div>
    <form-error :inline="false" :error="error" />
  </div>
</template>

<script>
import FormError from './forms/FormError'

export default {
  components: {
    FormError
  },
  props: {
    value: String,
    title: String,
    baseline: String,
    name: String,
    placeholder: String,
    error: [String, Array, Object],
    maxFileSize: {
      type: Number,
      default: 5000000
    },
    accept: {
      type: String,
      default: ".doc,.docs,.png,.jpg,.xls,.xlsx,.pdf"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: [],
      active: false
    }
  },
  computed: {
    getPlaceholder() {
      return this.multiple || !this.files.length
        ? this.placeholder
        : this.files[0].name;
    },
    getFileSize () {
      return this.files.length ? parseInt(this.files[0].size / 1000) + ' Ko' : ''
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    extensions() {
      return this.accept.replace(/[\[\].]+/g, "").split(",");
    }
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
    onChange(event) {
      this.replaceInputFile(event.target.files)
    },
    replaceInputFile(files) {
      this.files = [...files].filter(
        file =>
          file.size < this.maxFileSize &&
          this.extensions.includes(this.getFileExtension(file))
      );
      if (this.files.length) {
        this.$emit("file-change", this.multiple ? this.files : this.files[0]);
      } else {
        this.$emit("file-change", this.multiple ? [] : null);
      }

      if (this.files.length !== files.length) {
        alert("Fichier trop volumineux ou extension non supportée");
      }
    },
    onDrop(event) {
      this.replaceInputFile(event.dataTransfer.files);
    },
    getFileExtension(file) {
      return file.name.split(".").pop();
    },
  }
};
</script>

<style scoped>
/* purgecss start ignore */
.dropzone {
  @apply relative duration-300 min-h-127px rounded-10px border border-dashed border-blue-200 pt-5 pb-27px;

  &.has-error {
    @apply border-orange-500;
  }
}

.dropzone-custom-content {
  @apply absolute w-full h-full flex flex-col items-center justify-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center;

  .icon-upload { font-size: 24px; }

  .dropzone-title {
    @apply text-h5 my-8px font-medium font-title text-blue-900
  }

  .dropzone-baseline {
    @apply inline-block pb-2px relative text-button-3 text-blue-300 font-medium;

    &::after {
      content: '';
      @apply absolute bottom-0 left-0 w-full bg-blue-300;
      height: .1rem;
    }

    &:hover {
      @apply text-blue-900;
    }
  }
}
/* purgecss end ignore */
</style>